
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const SquareMultiple20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M6.09 4H5.05A2.5 2.5 0 0 1 7.5 2H14a4 4 0 0 1 4 4v6.5a2.5 2.5 0 0 1-2 2.45v-1.04c.58-.2 1-.76 1-1.41V6a3 3 0 0 0-3-3H7.5c-.65 0-1.2.42-1.41 1ZM4.5 5A2.5 2.5 0 0 0 2 7.5v8A2.5 2.5 0 0 0 4.5 18h8a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 12.5 5h-8ZM3 7.5C3 6.67 3.67 6 4.5 6h8c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 0 1 3 15.5v-8Z"
            fill="currentColor"
        />
    </svg>
}